import type { IStore } from 'old-store/types';

export const selectMessage = (state: IStore) => state.messages.message;
export const selectIsOpenedMessage = (state: IStore) => state.messages.isOpened;
